export const spanMap = {
  1: 10,
  2: 8,
  3: 6,
};
